import { teamMemberConnectionService } from "../../../services/connections/teamMemberService";
import { SystemEntityCollections } from "../../../shared/enums/shared-enums";
import { TeamMember } from "../../../types/teamMember";
import useTeamMemberLogic from "../../logic/connections/teamMemberLogic";
import useConnectionQueryClient from "./connectionQueryClient";

const useTeamMemberQuery = (
  systemLanguageType: TeamMember["system_language_type"]
) => {
  const { defaultTeamMember, getDisplayName } = useTeamMemberLogic(
    null,
    null,
    systemLanguageType
  );
  return useConnectionQueryClient<TeamMember>({
    defaultConnection: defaultTeamMember,
    service: teamMemberConnectionService,
    collection: SystemEntityCollections.TEAM_MEMBER,
    snackbarDisplayName: getDisplayName,
  });
};

export default useTeamMemberQuery;
